import React from 'react'

const Footer = () => {
  return (
   <span className='creator'>- By Himanshu Singh</span>
  )
}

export default Footer